import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import ProfileReducer from "./auth/profile/reducer";

// Projects
import ProjectsReducer from "./projects/reducer";
import ProcessLogsReducer from "./projects/processLogs/reducer";

// Contact Messages
import ContactMessagesReducer from "./contactMessages/reducer";

// Environment
import EnvironmentReducer from "./environment/reducer";


const rootReducer = combineReducers({
    Layout: LayoutReducer,
    Login: LoginReducer,
    Account: AccountReducer,
    ForgetPassword: ForgetPasswordReducer,
    Profile: ProfileReducer,
    Projects: ProjectsReducer,
    ProcessLogs: ProcessLogsReducer,
    ContactMessages: ContactMessagesReducer,
    Environment: EnvironmentReducer
});

export default rootReducer;